module.exports = "<svg slot=\"extra\" class=\"svg\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 8\" preserveAspectRatio=\"xMaxYMax meet\"><path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#A4F14A\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M0 3.98l3.97 3.3L10.92 1\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/check-green.svg
// module id = dRdQ
// module chunks = 5